import { render } from "./visionMissionPage.vue?vue&type=template&id=46240a83&scoped=true"
const script = {}

import "./visionMissionPage.vue?vue&type=style&index=0&id=46240a83&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46240a83"]])

export default __exports__